import React from 'react';

import { Hint } from '@v2/components/ui/Hint';
import { Box, Skeleton } from '@mui/material';
import { formatNumber } from '../utils';


interface LabelProps {
  name: string;
  value?: number;
  change?: number;
  id: string;
  showLoading: boolean;
  tooltip?: React.ReactNode;
}

const Label = ({ name, value, change, id, showLoading = true, tooltip }: LabelProps) => {
  const isPositive = change && change > 0;
  return (
    <Box width="180px" textAlign="left" color="#13171A">
      <Box marginBottom="8px" fontSize="16px" fontWeight={700}>
        {name}
        {tooltip && <span style={{ marginLeft: '4px' }}><Hint>{tooltip}</Hint></span>}
      </Box>
      <Box display="flex" alignItems="end">
        <>
          {showLoading && (
            <Box width="100%">
              <Box width="fit-content">
                <Skeleton variant="text" width="140px" height="40px" />
              </Box >
            </Box >
          )}
          {!!value && !showLoading && (
            <>
              <Box marginRight="8px" fontSize="32px" fontWeight={700}>
                {id === 'revenue' || id === 'spend' ? '$' : ''}
                {formatNumber(value)}
                {id === 'roas' ? 'x' : ''}
              </Box>
              {change && (
                <Box
                  paddingBottom="2px"
                  fontWeight={400}
                  fontSize="16px"
                  color={isPositive ? '#0CA672' : '#DB4C4C'}
                >
                  {formatNumber(change)}%
                </Box>
              )}
            </>
          )}
          {!value && !showLoading && (
            <Box
              fontSize="32px"
              fontWeight={700}
              height="40px"
              marginLeft="8px"
            >
              -
            </Box>
          )}
        </>
      </Box>
    </Box>
  );
};

export default Label;
